<template>
    <div>
        <v-row>
            <v-col>
                <v-card
                    color="#039BE5"
                    dark
                    height=190
                >
                        <v-card-title><div class="title">HORA - 11:00</div></v-card-title>

                        <v-card-text class="center"><h1 class="fuente-mediana">PH</h1></v-card-text>
                        

                        <v-card-text class="center">
                                <h1 class="parpadea fuente-grande">10,2%</h1>
                        </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card
                    color="#039BE5"
                    dark
                    height=190
                >
                        <v-card-title><div class="title">HORA - 11:20</div></v-card-title>
                        <v-card-text class="center"><h1 class="fuente-mediana">GRASA</h1></v-card-text>
                        <v-card-text class="center">
                                <h1 class="parpadea fuente-grande">21%</h1>
                        </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card
                    color="#2E7D32"
                    dark
                    height=190
                >
                        <v-card-title><div class="title">HORA - 11:00</div></v-card-title>
                        <v-card-text class="center"><h1 class="fuente-mediana">BS</h1></v-card-text>
                        <v-card-text class="center">
                                <h1 class="parpadea fuente-grande">11,7%</h1>
                        </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card
                    color="#039BE5"
                    dark
                    height=190
                >
                        <v-card-title><div class="title">HORA - 11:00</div></v-card-title>
                        <v-card-text class="center"><h1 class="fuente-mediana">PROTEINA</h1></v-card-text>
                        <v-card-text class="center">
                                <h1 class="parpadea fuente-grande">56%</h1>
                        </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card
                    color="blue-grey darken-1"
                    dark
                    height=190
                >
                        <v-card-title><div class="title">HORA - 10:15</div></v-card-title>
                        <v-card-text class="center"><h1 class="fuente-mediana">TVN</h1></v-card-text>
                        <v-card-text class="center">
                                <h1 class=" parpadea fuente-grande">15%</h1>
                        </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card
                    color="deep-orange darken-3"
                    dark
                    height=190
                >
                        <v-card-title><div class="title">HORA - 12:00</div></v-card-title>

                        <!-- <v-card-title><div class="title"><h1>T°</h1></div></v-card-title> -->
                        <v-card-text class="center"><h1 class="fuente-mediana">T°</h1></v-card-text>

                        <v-card-text class="center">
                                <h1 class=" parpadea fuente-grande">75°C</h1>
                        </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    data:()=>({

    })
}
</script>
<style scoped>
.fuente-mediana{
    font-size: 50px;
    font-weight:900;
}
.fuente-grande{
    font-size: 80px;
}

/*animacion de parpadeo */
.parpadea {
  
  animation-name: parpadeo;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 1.5s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

@-moz-keyframes parpadeo{  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}

@-webkit-keyframes parpadeo {  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}

@keyframes parpadeo {  
  0% { opacity: 1.0; }
  25% {opacity: 0.75}
  50% { opacity: 0.50; }
  75% {opacity: 0.75}
  100% { opacity: 1.0; }
}
/*animacion de parpadeo */

</style>